namespace TabAurous.OMS {
    export interface MoldMasterForm {
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        RackNo: Serenity.StringEditor;
    }

    export class MoldMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.MoldMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MoldMasterForm.init)  {
                MoldMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(MoldMasterForm, [
                    'Code', w0,
                    'Name', w0,
                    'RackNo', w0
                ]);
            }
        }
    }
}
